import dayjs from "dayjs";

const TableDateFormatter = ({ date }: { date: string | Date }) => {
  return <div>{dayjs(new Date(date)).format("DD/MM/YYYY HH:mm")}</div>;
};

export default TableDateFormatter;
